module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DefaultLayout', [(_vm.getCurrentRTLoading || _vm.getCourseLoading) ? _c('div', {
    staticClass: "text-center mt-6"
  }, [_c('p', {
    staticClass: "mb-2.5"
  }, [_vm._v("Loading RoundTable")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-spinner')], 1)]) : _c('div', {
    staticClass: "max-w-screen-3xl px-5 py-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [(_vm.getCurrentRT.sequence_id !== null) ? _c('DropdownMenu', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function() {
        return [_c('button', {
          staticClass: "bg-indigo-500 rounded-full py-1.5 px-3 flex items-center justify-between space-x-2"
        }, [_c('img', {
          staticClass: "w-4 h-4",
          attrs: {
            "src": "/static/roundtable_icons/sequence_icon.svg"
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "fa-solid text-xs fa-chevron-down text-indigo-100"
        })])]
      },
      proxy: true
    }, {
      key: "menu-content",
      fn: function() {
        return [_c('ul', {
          staticClass: "absolute z-50 bg-white border border-solid border-gray-200 max-w-lg rounded-lg mt-2 shadow-sm"
        }, _vm._l((_vm.getCurrentRT.roundtables_sequence), function(roundtable, index) {
          return _c('li', {
            key: index,
            staticClass: "border-b border-gray-200 py-2 px-3 hover:bg-gray-100 cursor-pointer",
            class: [{
              'border-none': index + 1 === _vm.getCurrentRT.roundtables_sequence.length
            }, {
              'bg-gray-100': roundtable.id === _vm.$route.params.roundtableID
            }],
            on: {
              "click": function($event) {
                return _vm.handleClickSequenceRoundTable(roundtable.id, roundtable.type)
              }
            }
          }, [_c('div', {
            staticClass: "flex justify-start items-center space-x-2"
          }, [_c('div', {
            staticClass: "w-7 h-7"
          }, [_c('div', {
            staticClass: "flex items-center justify-center rounded-full h-7 w-7",
            class: [{
              'bg-blue': roundtable.type === 'written' || roundtable.type === 'roundtable',
              'bg-green-light': roundtable.type === 'verbal' || roundtable.type === 'live_discussion'
            }]
          }, [_c('img', {
            staticClass: "w-3 h-3",
            class: [{
              'w-3 h-3': roundtable.type === 'written'
            }, {
              'w-3 pt-0.5 h-3': roundtable.type === 'verbal'
            }],
            attrs: {
              "src": roundtable.type === 'written' || roundtable.type === 'roundtable' ? '/static/roundtable_icons/written_icon.svg' : '/static/roundtable_icons/verbal_icon.svg'
            }
          })])]), _vm._v(" "), _c('h6', {
            staticClass: "truncate",
            attrs: {
              "title": roundtable.title
            }
          }, [_vm._v("\n                    " + _vm._s(roundtable.title) + "\n                  ")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 4038379384)
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text-2xl font-extrabold truncate font-manrope text-blueGray-800",
    attrs: {
      "title": _vm.getCurrentRT.title
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getCurrentRT.title) + "\n        ")]), _vm._v(" "), (_vm.rt_integration) ? _c('div', {
    staticClass: "ml-2"
  }, [_c('a', {
    attrs: {
      "href": _vm.assignmentUrl,
      "target": "blank"
    }
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": _vm.assignmentIcon,
      "width": "20px",
      "height": "20px"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.getCurrentRT.sequence_id !== null) ? _c('div', {
    staticClass: "bg-indigo-100 text-xs border border-solid border-indigo-500 text-indigo-500 rounded-full px-2 py-0.5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.current_sequence_number + 1))]), _vm._v(" "), _c('span', {
    staticClass: "ml-0.5 mr-1"
  }, [_vm._v("of")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getCurrentRT.roundtables_sequence.length))])])]) : _vm._e()], 1), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [(_vm.showQuestionIcon) ? _c('div', {
    staticClass: "cursor-pointer text-lg font-bold mr-2",
    on: {
      "click": _vm.showFirstRTWelcomeModal
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-lg text-blueGray-700 hover:text-blueGray-800"
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "px-5 py-2 bg-pinky hover:bg-pinky-dark rounded-full text-white font-manrope font-semibold text-sm disabled:opacity-50",
    on: {
      "click": function($event) {
        _vm.isInviteStudentModalOpen = true
      }
    }
  }, [_c('span', {
    staticClass: "truncate"
  }, [_vm._v("Invite Students")])]), _vm._v(" "), _c('OnlineRoundableMenu', {
    attrs: {
      "sequence_roundtables": _vm.getCurrentRT.roundtables_sequence
    },
    on: {
      "showModalEndRoundtableConfirm": _vm.openToggleEndRoundtableConfirm,
      "showCloseDateModal": function($event) {
        _vm.show_close_date_modal = true
      },
      "showDuplicateModal": function($event) {
        _vm.show_duplicate_modal = true
      },
      "showShareActivityModal": _vm.showShareRoundtableModal,
      "rtIntegrationAssignment": _vm.rtIntegrationAssignment,
      "showFollowUp": function (type) { return _vm.handleOpenStartFollowUP(type); },
      "addResponse": _vm.goToSubmitResponsePage
    }
  })], 1) : (_vm.getCurrentRT.enable_annonymous && !_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex items-center"
  }, [(_vm.showQuestionIcon) ? _c('div', {
    staticClass: "cursor-pointer text-lg font-bold mx-4",
    on: {
      "click": _vm.showFirstRTWelcomeModal
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info text-lg text-coolGray-700"
  })]) : _vm._e(), _vm._v(" "), _c('IdentityReveal', {
    staticClass: "flex items-center mt-1 md:mt-0"
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.isRoundtableEnded) ? _c('div', {
    staticClass: "bg-red-100 table mt-1 border py-1.5 px-4 border-solid border-red-400 text-red-500 rounded-full"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/closed_on.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_vm._v("\n          Closed on " + _vm._s(_vm.roundTableCloseDate) + "\n        ")])])]) : _vm._e(), _vm._v(" "), (_vm.getCurrentRT.end_date !== null && _vm.isRoundtableEnded === false) ? _c('div', {
    staticClass: "bg-gray-100 table mt-1 border py-1.5 px-4 border-solid border-gray-300 text-gray-500 rounded-full"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/roundtable_icons/closes_on.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_vm._v("\n          Closes on " + _vm._s(_vm.roundTableCloseDate) + "\n        ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex lg:flex-row md:flex-col flex-col h-full gap-y-1 gap-x-1 pt-3"
  }, [_c('div', {
    class: _vm.gridLeft,
    attrs: {
      "id": "rigthGrid"
    }
  }, [_c('div', {
    staticClass: "bg-white border border-coolGray-200 rounded-lg"
  }, [_c('div', [_c('div', {
    staticClass: "flex justify-between items-center w-full pt-2.5 pr-2 border-b border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "flex items-center rounded-t overflow-x-auto"
  }, [_c('div', {
    staticClass: "px-5 select-none cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'prompt'
    },
    staticStyle: {
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('prompt')
      }
    }
  }, [_vm._v("\n                  Prompt\n                ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "select-none px-5 cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'settings'
    },
    staticStyle: {
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('settings')
      }
    }
  }, [_vm._v("\n                  Settings\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "select-none px-5 cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'discussion'
    },
    staticStyle: {
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('discussion')
      }
    }
  }, [_vm._v("\n                  Discussion\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "px-5 select-none cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'summary'
    },
    staticStyle: {
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('summary')
      }
    }
  }, [_vm._v("\n                  Summary\n                ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "px-5 select-none cursor-pointer",
    class: {
      'border-primary text-primary border-b': _vm.tab === 'individual_summary'
    },
    staticStyle: {
      "height": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.goToTab('individual_summary')
      }
    }
  }, [_vm._v("\n                  Table\n                ")]) : _vm._e()]), _vm._v(" "), _c('DropdownMenu', {
    scopedSlots: _vm._u([{
      key: "toggle",
      fn: function() {
        return [(_vm.show_tab_menu === true) ? _c('button', {
          staticClass: "rounded-full hover:bg-gray-100 mb-2.5 items-center justify-between space-x-2"
        }, [_c('i', {
          staticClass: "fa-solid fa-circle mt-0.5 text-primary",
          staticStyle: {
            "font-size": "5px"
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tab === 'individual_summary' ? 'Table' : _vm.tab.charAt(0).toUpperCase() + _vm.tab.slice(1)))]), _vm._v(" "), _c('i', {
          staticClass: "fa-solid text-xs fa-chevron-down text-gray-700"
        })]) : _vm._e()]
      },
      proxy: true
    }, {
      key: "menu-content",
      fn: function() {
        return [_c('ul', {
          staticClass: "absolute z-10 bg-white border border-solid border-gray-200 max-w-lg rounded-lg mt-2 shadow-sm"
        }, [_c('li', {
          staticClass: "cursor-pointer py-2 px-3 hover:bg-gray-100 border-b border-solid border-gray-200",
          on: {
            "click": function($event) {
              return _vm.goToTab('prompt')
            }
          }
        }, [_vm._v("\n                      Prompt\n                    ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('li', {
          staticClass: "cursor-pointer py-2 px-3 hover:bg-gray-100 border-b border-solid border-gray-200",
          on: {
            "click": function($event) {
              return _vm.goToTab('settings')
            }
          }
        }, [_vm._v("\n                      Settings\n                    ")]) : _vm._e(), _vm._v(" "), _c('li', {
          staticClass: "cursor-pointer py-2 px-3 hover:bg-gray-100 border-b border-solid border-gray-200",
          on: {
            "click": function($event) {
              return _vm.goToTab('discussion')
            }
          }
        }, [_vm._v("\n                      Discussion\n                    ")]), _vm._v(" "), _c('li', {
          staticClass: "cursor-pointer py-2 px-3 hover:bg-gray-100 border-b border-solid border-gray-200",
          on: {
            "click": function($event) {
              return _vm.goToTab('summary')
            }
          }
        }, [_vm._v("\n                      Summary\n                    ")]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse) ? _c('li', {
          staticClass: "cursor-pointer py-2 px-3 hover:bg-gray-100",
          on: {
            "click": function($event) {
              return _vm.goToTab('individual_summary')
            }
          }
        }, [_vm._v("\n                      Table\n                    ")]) : _vm._e()])]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.tab === 'prompt') ? _c('div', {
    staticClass: "text-gray-800"
  }, [(!_vm.hasTeacherPermissionsInCourse) ? _c('div', {
    staticClass: "flex items-center space-x-2 mr-3 -mt-2"
  }, [_c('img', {
    staticClass: "w-5 h-5 rounded-full",
    attrs: {
      "src": _vm.author_avatar
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-manrope text-gray-800"
  }, [_vm._v("by " + _vm._s(_vm.author_name))])]) : _c('button', {
    staticClass: "flex items-center space-x-2 hover:underline -mt-2 mr-3.5 rounded",
    on: {
      "click": function($event) {
        return _vm.handleEditPrompt()
      }
    }
  }, [_c('h6', [_vm._v("Edit Prompt")])])]) : (_vm.tab === 'discussion') ? _c('div', [_c('Tooltip', {
    attrs: {
      "text": "Show List",
      "styleTooltip": "top-0 right-full -mt-2.5 mr-2"
    }
  }, [_c('toggle-button', {
    staticClass: "toggle-button-class -mt-3",
    attrs: {
      "sync": true,
      "labels": false,
      "color": "#72ccd7"
    },
    model: {
      value: (_vm.toggle_responses),
      callback: function($$v) {
        _vm.toggle_responses = $$v
      },
      expression: "toggle_responses"
    }
  })], 1)], 1) : (_vm.tab === 'settings') ? _c('div', {
    staticClass: "-mt-2 flex items-center space-x-3 mr-3"
  }, [(_vm.is_button_save_setting_enable !== true) ? _c('button', {
    staticClass: "sample hover:underline text-gray-500 rounded disabled:opacity-50",
    on: {
      "click": _vm.forceRerender
    }
  }, [_vm._v("\n                  Cancel\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "sample hover:underline rounded disabled:opacity-50",
    class: _vm.is_button_save_setting_enable === true ? 'text-gray-400 cursor-not-allowed' : 'text-gray-800',
    attrs: {
      "disabled": _vm.is_button_save_setting_enable
    },
    on: {
      "click": function($event) {
        _vm.is_settings_confirm_modal_open = true
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-floppy-disk mr-1.5"
  }), _vm._v("Save\n                ")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: _vm.tab === 'prompt' ? 'prompt-heigth overflow-y-auto' : ''
  }, [(_vm.getCurrentRT.id && _vm.isLoadingWritten === false) ? _c(_vm.component_to_render, {
    key: _vm.componentKey,
    ref: "childComponent",
    tag: "Component",
    on: {
      "editAssessmentPoint": _vm.editAssessmentPoint,
      "editPeerQuestion": _vm.editPeerQuestion,
      "deletePeerQuestion": _vm.deletePeerQuestion,
      "cancelSettingsChanges": _vm.forceRerender,
      "handleSettingsChange": function (value) { return (_vm.is_button_save_setting_enable = value); },
      "openAssessmentTab": function($event) {
        _vm.open_assessment = true;
        _vm.toggle_responses = true;
      },
      "orderedSubmissions": function (value) { return (_vm.orderedSubmissions = value); }
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.showRightContainer) ? _c('div', {
    class: _vm.gridRight
  }, [(_vm.tab === 'discussion') ? _c('div', {
    staticClass: "sticky top-1"
  }, [(!_vm.genie_recap) ? _c('div', [(!_vm.open_assessment) ? _c('OnlineStudentsList', {
    key: "list",
    attrs: {
      "inViewport": _vm.first_in_viewport
    },
    on: {
      "enableSubmission": function () { return (_vm.isLoadingWritten = false); },
      "showInviteModal": _vm.showShareRoundtableModal,
      "selectSubmission": _vm.selectSubmission,
      "unsubmittedDraftResponse": _vm.unsubmittedDraftResponse,
      "draftEvaluations": _vm.showDraftEvaluations
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open_assessment) ? _c('OnlineStudentsAssessment', {
    attrs: {
      "orderedSubmissions": _vm.orderedSubmissions
    },
    on: {
      "backToOnlineStudentList": function($event) {
        _vm.open_assessment = false
      }
    }
  }) : _vm._e()], 1) : _c('GenieRecapSideBar', {
    on: {
      "backToOnlineStudentList": function($event) {
        _vm.genie_recap = false
      },
      "startFollowUp": function (type) { return _vm.handleOpenFollowUpQuestions(type); },
      "editFollowUpQuestions": _vm.editFollowUpQuestions
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showSubmissionContainer) ? _c('div', {
    staticClass: "bg-white border-coolGray-200 border rounded-lg h-full"
  }, [_c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "px-4 py-0.5 flex justify-between items-center border-b border-solid border-gray-200",
    staticStyle: {
      "height": "41px"
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5"
  }, [_c('h5', {
    staticClass: "text-sm text-gray-800"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("My Submission")]), _vm._v(" "), _c('span', {
    staticClass: "font-manrope"
  }, [_vm._v("(" + _vm._s(_vm.wordCount) + " words)")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center"
  }, [_c('h6', {
    staticClass: "mr-3 text-gray-300"
  }, [_vm._v("\n                  " + _vm._s(_vm.draftResponseMessage) + "\n                ")])])]), _vm._v(" "), (!_vm.isLoadingWritten) ? _c('SubmissionForm', {
    attrs: {
      "submissionData": _vm.getMySubmission
    },
    on: {
      "updateDiscussion": _vm.goToDiscussion,
      "submissionChanged": _vm.handleSubmissionChange,
      "changingPrompt": _vm.isPromptChanging,
      "wordcount": function($event) {
        _vm.wordCount = $event
      },
      "enableEditSubmission": function (isEnable) { return (_vm.isEnableEditSubmission = isEnable); },
      "messageDraftResponse": function (message) { return (_vm.draftResponseMessage = message); }
    }
  }) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    key: "dialogs"
  }, [(_vm.show_share_roundtable_modal) ? _c('ShareActivityModal', {
    attrs: {
      "activityType": 'written',
      "preSelectedTab": _vm.pre_selected_tab_in_share_modal
    },
    on: {
      "close": _vm.closeShareModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_end_reopen_modal) ? _c('CloseRoundTableModal', {
    attrs: {
      "title": _vm.confirm.title,
      "content": _vm.confirm.content
    },
    on: {
      "close": function($event) {
        _vm.show_end_reopen_modal = false
      },
      "hardClose": function (hardClose) { return (_vm.hard_close = hardClose); },
      "closeRoundTable": _vm.handleCloseRoundTable
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_duplicate_modal) ? _c('DuplicateRoundTableModal', {
    on: {
      "close": function($event) {
        _vm.show_duplicate_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_close_date_modal) ? _c('close-date-modal', {
    on: {
      "close": function($event) {
        _vm.show_close_date_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.open_google_classroom_dialog) ? _c('integrations-connect-modal', {
    on: {
      "close": function($event) {
        _vm.open_google_classroom_dialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_integration_connected) ? _c('integration-connected-modal', {
    attrs: {
      "integration": _vm.integration
    },
    on: {
      "close": function($event) {
        _vm.is_integration_connected = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_point_creation_modal) ? _c('create-new-point-modal', {
    attrs: {
      "activityType": 'written',
      "tag": _vm.selected_point_tag,
      "rts": _vm.roundtables_with_point,
      "assessment_scale": _vm.selected_point_scale
    },
    on: {
      "deleteAssessmentPoint": _vm.deleteAssessmentPoint,
      "close": function($event) {
        _vm.show_point_creation_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sync_assessment) ? _c('SyncAssessmentDataModal', {
    attrs: {
      "activityType": _vm.activityType,
      "edLink": _vm.edLink,
      "selectedIntegration": _vm.selected_integration,
      "logo": _vm.logo,
      "integrationName": _vm.integrationName
    },
    on: {
      "close": function($event) {
        _vm.sync_assessment = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_alert_assessment_changing) ? [_c('pl-dialog', {
    attrs: {
      "size": "confirm_size",
      "title": 'Heads up!',
      "disableOutsideClick": true,
      "showCloseButton": false
    }
  }, [_c('div', {
    staticClass: "px-6 flex flex-col pb-5"
  }, [_c('div', {
    staticClass: "flex-grow mb-6"
  }, [_c('div', [_c('p', {
    staticClass: "mb-4"
  }, [_vm._v("\n                  Changing (or deleting) this assessment criteria for this\n                  RoundTable will change (or delete) it for all of the other\n                  RoundTables in this course that also use this criteria:\n                ")])]), _vm._v(" "), _c('ul', _vm._l((_vm.roundtables_with_point), function(roundtable) {
    return _c('li', {
      key: roundtable.id,
      staticClass: "mb-1"
    }, [_c('span', {
      staticClass: "font-semibold font-poppins"
    }, [_vm._v("- " + _vm._s(roundtable.title))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-4 w-full"
  }, [_c('button', {
    staticClass: "bg-primary w-full hover:bg-primary-dark text-white rounded px-3 py-2",
    on: {
      "click": _vm.closeAssessmentChangingAlert
    }
  }, [_vm._v("\n                Okay, Got it\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center items-center space-x-2"
  }, [_c('span', {
    staticClass: "font-poppins text-gray-800"
  }, [_vm._v("Do not show this anymore")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.not_show_heads_up_info),
      expression: "not_show_heads_up_info"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.not_show_heads_up_info) ? _vm._i(_vm.not_show_heads_up_info, null) > -1 : (_vm.not_show_heads_up_info)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.not_show_heads_up_info,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.not_show_heads_up_info = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.not_show_heads_up_info = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.not_show_heads_up_info = $$c
        }
      }
    }
  })])])])])] : _vm._e(), _vm._v(" "), (_vm.show_delete_point_modal) ? _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "title": "Delete Criteria Point",
      "size": "confirm_size"
    },
    on: {
      "close": _vm.closeDeletePointModal
    }
  }, [_c('div', {
    staticClass: "h-full w-full overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex flex-col h-full pb-5"
  }, [_c('div', {
    staticClass: "overflow-y-auto h-full px-6 mb-4"
  }, [_c('div', {
    staticClass: "text-gray-900 font-poppins font-light"
  }, [_vm._v("\n                You are deleting this criteria point from this roundtable. This action cannot be undone.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col px-5 flex-grow h-full"
  }, [_c('div', {
    staticClass: "flex flex-col w-full space-y-1.5 mb-2"
  }, [_c('span', {
    staticClass: "font-poppins text-gray-900"
  }, [_vm._v("Please type in \"confirm\" to delete")]), _vm._v(" "), _c('input', {
    ref: "confirm-input",
    staticClass: "py-2 px-3 w-full border border-solid border-gray-200 bg-white rounded-md focus-within:border-red-500",
    attrs: {
      "placeholder": "Type 'confirm' to delete roundTable from the course",
      "type": "text"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmDeleteAssessmentPoint()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "hover:bg-gray-50 bg-white py-2 flex items-center justify-center space-x-2 text-blueGray-500 font-medium w-full rounded-md border border-solid border-gray-200",
    on: {
      "click": function($event) {
        _vm.show_delete_point_modal = false
      }
    }
  }, [_c('span', [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "bg-red-500 transition-colors py-2 flex items-center justify-center space-x-2 text-red-50 font-semibold w-full rounded-md border border-solid border-red-500",
    on: {
      "click": _vm.confirmDeleteAssessmentPoint
    }
  }, [_c('span', [_vm._v("Confirm")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.show_edit_question_modal) ? _c('pl-dialog', {
    attrs: {
      "size": 'sm',
      "title": 'Edit Question',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.show_edit_question_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "px-7 pt-7 pb-4 flex-grow overflow-y-auto"
  }, [_c('div', {
    staticClass: "text-xs"
  }, [_vm._v("Question")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.peer_assessment_questions[_vm.question_to_edit_index].question
      ),
      expression: "\n              peer_assessment_questions[question_to_edit_index].question\n            "
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (
        _vm.peer_assessment_questions[_vm.question_to_edit_index].question
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.peer_assessment_questions[_vm.question_to_edit_index], "question", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center justify-center my-5"
  }, [_c('button', {
    staticClass: "px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-500 font-semibold mr-2.5",
    on: {
      "click": function($event) {
        _vm.show_edit_question_modal = false
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "sample px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    on: {
      "click": _vm.saveQuestion
    }
  }, [_vm._v("\n            Edit\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.show_delete_question_modal) ? _c('DialogDeleteConfirm', {
    attrs: {
      "optionalText": "question"
    },
    on: {
      "close": function($event) {
        _vm.show_delete_question_modal = false
      },
      "actionConfirmed": _vm.confirmDeletePeerQuestion
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_integrations_modal) ? _c('ConnectIntegrationsAssessmentModal', {
    on: {
      "close": function($event) {
        _vm.show_integrations_modal = false
      },
      "goToInviteStudents": _vm.showShareRoundtableModalIntegrationsTab
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalSampleOpen) ? _c('ModalSampleRoundTable', {
    attrs: {
      "dataSample": _vm.urlVideoSample
    },
    on: {
      "close": function($event) {
        _vm.isModalSampleOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_student_settings) ? _c('StudentSettings', {
    attrs: {
      "submission": _vm.submission
    },
    on: {
      "close": function($event) {
        _vm.show_student_settings = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEditRTModalOpen) ? _c('EditRoundtableModal', {
    attrs: {
      "id": _vm.getCurrentRT.id
    },
    on: {
      "close": function($event) {
        _vm.isEditRTModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.openOnChangeSubmission && _vm.getMySubmission.prompt_response !== null
  ) ? _c('AreYouSureChangeTab', {
    attrs: {
      "route_to_change": _vm.selectedTabBeforeLeave,
      "submissionResponse": _vm.changingSubmissionOnEditor,
      "wordCount": _vm.wordCountFromSubmission
    },
    on: {
      "close": function($event) {
        _vm.openOnChangeSubmission = false
      },
      "changeTabAndLeaveChanges": _vm.leaveSubmissionChanges,
      "closeModal": function () { return (_vm.isSubmissionChanged = false); },
      "updateDiscussion": _vm.goToDiscussion
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isUnsubmittedResponseOpen) ? _c('UnsubmittedDraftResponse', {
    attrs: {
      "studentSubmission": _vm.selectedUnsubmmitedSubmission
    },
    on: {
      "close": function($event) {
        _vm.isUnsubmittedResponseOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_leave_edit_submission === true) ? _c('LeaveEditSubmissionModal', {
    attrs: {
      "route_to_go": _vm.route_selected,
      "tab_to_go": _vm.selectedTabBeforeLeave,
      "submissionResponse": _vm.changingSubmissionOnEditor
    },
    on: {
      "close": function($event) {
        return _vm.handleCloseLeaveSubmission()
      },
      "updateDiscussion": _vm.goToDiscussion
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_RT_Welcome_modal) ? _c('roundTable-welcome-modal', {
    attrs: {
      "activityType": "online",
      "data": _vm.welcomeRoundTableData
    },
    on: {
      "close": _vm.closeRTWelcomeModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInviteStudentModalOpen) ? _c('InviteStudentsModal', {
    on: {
      "close": function($event) {
        _vm.isInviteStudentModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_new_roundtable_open) ? _c('NewRoundTable', {
    attrs: {
      "outside_option": _vm.outside_option,
      "follow_up_from": _vm.getCurrentRT
    },
    on: {
      "close": function($event) {
        _vm.is_new_roundtable_open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.templates_modal) ? _c('TemplatesModal', {
    attrs: {
      "activityType": 'written'
    },
    on: {
      "close": _vm.closeTemplateModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show_draft_evalutions) ? _c('DraftEvaluationsModal', {
    attrs: {
      "draftEvaluations": _vm.draft_evaluations
    },
    on: {
      "close": function($event) {
        _vm.show_draft_evalutions = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_to_show_genie_grader_confirm === true) ? _c('GenieAssessmentConfirmModal', {
    attrs: {
      "type_genie_assessment": _vm.type_genie_assessment,
      "roundtable": _vm.getCurrentRT,
      "profile": _vm.getProfile
    },
    on: {
      "close": function($event) {
        _vm.is_to_show_genie_grader_confirm = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_settings_confirm_modal_open) ? _c('SaveSettingsModal', {
    on: {
      "close": function($event) {
        return _vm.handleCloseSaveSettings()
      },
      "handleSaveSettings": _vm.saveSettingsTab
    }
  }) : _vm._e(), _vm._v(" "), (_vm.is_genie_feedback_modal_open === true) ? _c('GenieFeedbackModal', {
    attrs: {
      "submission": _vm.submission_genie_feedback
    },
    on: {
      "close": function($event) {
        _vm.is_genie_feedback_modal_open = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.edit_follow_up_questions_modal) ? _c('EditFollowUpQuestions', {
    on: {
      "close": function($event) {
        _vm.edit_follow_up_questions_modal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFollowUpOpen === true) ? _c('Draft', {
    attrs: {
      "id": _vm.selectedRoundTableToFollow.draftId,
      "type": _vm.selectedRoundTableToFollow.type,
      "isFollowUp": true
    },
    on: {
      "close": function($event) {
        _vm.isFollowUpOpen = false
      }
    }
  }) : _vm._e()], 2)]), _vm._v(" "), (_vm.hasTeacherPermissionsInCourse && _vm.showGeniePopover && _vm.getCourseDetail.id !== '151035ea-b4c7-484d-a07d-3505fa895cf7') ? _c('div', {
    staticClass: "fixed bottom-4 z-40 shadow-xl rounded-lg bg-white border border-solid border-gray-200 w-96 transition-all duration-1000 ease-in-out transform",
    class: {
      'opacity-100 scale-100': _vm.showGeniePopover,
      'opacity-0 scale-75': !_vm.showGeniePopover
    },
    staticStyle: {
      "left": "65px"
    }
  }, [_c('div', {
    staticClass: "flex flex-col space-y-5 px-5 pt-2.5 pb-4"
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex items-center space-x-2.5"
  }, [_c('i', {
    staticClass: "fa-regular fa-lightbulb text-base text-yellow-500"
  }), _vm._v(" "), _c('h6', {
    staticClass: "font-poppins font-semibold text-gray-800"
  }, [_vm._v("Parlay Tip")])]), _vm._v(" "), _c('button', {
    staticClass: "w-8 h-8 rounded-full hover:bg-gray-100 hover:text-primary",
    on: {
      "click": _vm.handleCloseGeniePopover
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-xmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "w-full relative"
  }, [(_vm.genie_teaching_page === 1) ? _c('img', {
    attrs: {
      "src": "/static/genie_feedback4.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.genie_teaching_page === 2) ? _c('img', {
    attrs: {
      "src": "/static/genie_feedback2.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.genie_teaching_page === 3) ? _c('img', {
    attrs: {
      "src": "/static/genie_feedback3.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2"
  }, [_c('h4', {
    staticClass: "font-poppins font-semibold text-base text-gray-800"
  }, [_vm._v("\n          Have you tried Genie Feedback for students?\n        ")]), _vm._v(" "), (_vm.genie_teaching_page === 1) ? _c('p', {
    staticClass: "font-poppins font-light text-gray-600"
  }, [_vm._v("\n          Before students submit, they will be able to ask the Genie for feedback\n          according to the RoundTable prompt and criteria.\n        ")]) : (_vm.genie_teaching_page === 2) ? _c('p', {
    staticClass: "font-poppins font-light text-gray-600"
  }, [_vm._v("\n          You will be able to see the feedback each student received and how they\n          changed their submission.\n        ")]) : (_vm.genie_teaching_page === 3) ? _c('p', {
    staticClass: "font-poppins font-light text-gray-600"
  }, [_vm._v("\n          Turn Genie Feedback "), _c('span', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("ON")]), _vm._v("\n          in your Settings.\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('button', {
    staticClass: "w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200",
    attrs: {
      "disabled": _vm.genie_teaching_page <= 1
    },
    on: {
      "click": function($event) {
        return _vm.handleChangePageTeaching('back')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blueGray-500",
    class: {
      'bg-blueGray-800': _vm.genie_teaching_page === 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blueGray-500",
    class: {
      'bg-blueGray-800': _vm.genie_teaching_page === 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-3 h-3 rounded-full bg-blueGray-500",
    class: {
      'bg-blueGray-800': _vm.genie_teaching_page === 3
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200",
    attrs: {
      "disabled": _vm.genie_teaching_page >= 3
    },
    on: {
      "click": function($event) {
        return _vm.handleChangePageTeaching('next')
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-chevron-right"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.isNewInstructionOpen === true) ? _c('NewInstruction', {
    on: {
      "close": function($event) {
        _vm.isNewInstructionOpen = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ddacb92a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/rtIndex.vue
// module id = 1296
// module chunks = 61